import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const IncidentTypeSetup = lazy(() => import('./IncidentTypeSetup'))
const IncidentTypeQueastionsSetup = lazy(() => import('./IncidentTypeQueastionsSetup'))
const CompanyProfile=lazy(()=>import('./CompanyProfile'))
const BrnchSetup=lazy(()=>import('./BranchSetup'))
const DepartmentsSetup=lazy(()=>import('./DepartmentsSetup'))
const LocationsSetups=lazy(()=>import('./LocationsSetup'))
const SubLocationsSetups=lazy(()=>import('./SubLocationsSetup'))
const SeveritySetup=lazy(()=>import('./SeveritySetup'))
const DesignationsSetup=lazy(()=>import('./DesignationsSetup'))
const UserSetup=lazy(()=>import('./UserSetup'))
const HazardGroupsSetup=lazy(()=>import('./HazardGroupsSetup'))
const HazardSetup=lazy(()=>import('./HazardSetup'))
const RiskTasksSetup=lazy(()=>import('./RiskTasksSetup'))
const RiskControllersSetups=lazy(()=>import('./RiskControllersSetups'))
const TrainingCategorySetup=lazy(()=>import('./TrainingCategorySetup'))
const TrainingTeamSetup=lazy(()=>import('./TrainingTeamSetup'))
const TeamMembersSetup=lazy(()=>import('./TeamMembersSetup'))

const DataSetupRoutes = [
    {
        path: '/incident_types',
        component: IncidentTypeSetup,
        auth: authRoleAccess.incidet_type_setup,
    },
    {
        path: '/incident_type_questions/:id',
        component: IncidentTypeQueastionsSetup,
        auth: authRoleAccess.incidet_type_setup,
    },
    {
        path: '/company_profile',
        component: CompanyProfile,
        auth: authRoleAccess.company_profile,
    },
    {
        path: '/branches',
        component: BrnchSetup,
        auth: authRoleAccess.company_dataSetup,
    },
    {
        path: '/departments',
        component: DepartmentsSetup,
        auth: authRoleAccess.company_dataSetup,
    },
     {
        path: '/locations',
        component: LocationsSetups,
        auth: authRoleAccess.company_dataSetup,
    },
    {
        path: '/sub_locations',
        component: SubLocationsSetups,
        auth: authRoleAccess.company_dataSetup,
    },
     {
        path: '/severity_impacts',
        component: SeveritySetup,
        auth: authRoleAccess.incidet_type_setup,
    },
     {
        path: '/designations',
        component: DesignationsSetup,
        auth: authRoleAccess.company_dataSetup,
    },
    {
        path: '/users',
        component: UserSetup,
        auth: authRoleAccess.user_management,
    },
    {
        path: '/hazard_groups',
        component: HazardGroupsSetup,
        auth: authRoleAccess.company_risk_assesment_dataSetup,
    },
    {
        path: '/hazard',
        component: HazardSetup,
        auth: authRoleAccess.company_risk_assesment_dataSetup,
    },
     {
        path: '/risk_task',
        component: RiskTasksSetup,
        auth: authRoleAccess.company_risk_assesment_dataSetup,
    },
    {
        path: '/risk_controllers',
        component: RiskControllersSetups,
        auth: authRoleAccess.company_risk_assesment_dataSetup,
    },
    {
        path: '/training_categories',
        component: TrainingCategorySetup,
        auth: authRoleAccess.trainingCategorySetup,
    },
    {
        path: '/training_teams',
        component: TrainingTeamSetup,
        auth: authRoleAccess.trainingTeamSetup,
    },
    {
        path: '/team_members/:id',
        component: TeamMembersSetup,
        auth: authRoleAccess.teamMembersSetup,
    }
   
    
]

export default DataSetupRoutes 